// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  structureId: __t.u64().primaryKey().name("structure_id"),
  worldId: __t.u64().name("world_id"),
  owner: __t.identity(),
  structureType: __t.string().name("structure_type"),
  cellX: __t.i32().name("cell_x"),
  cellZ: __t.i32().name("cell_z"),
  posX: __t.f32().name("pos_x"),
  posY: __t.f32().name("pos_y"),
  posZ: __t.f32().name("pos_z"),
  yaw: __t.f32(),
  modelAssetId: __t.u64().name("model_asset_id"),
  lotsUsed: __t.u8().name("lots_used"),
  maintPool: __t.i64().name("maint_pool"),
  powerPool: __t.i64().name("power_pool"),
  condition: __t.u32(),
  itemCap: __t.u32().name("item_cap"),
  itemCount: __t.u32().name("item_count"),
  cityId: __t.u64().name("city_id"),
  outsideCity: __t.bool().name("outside_city"),
  lastMaintAt: __t.timestamp().name("last_maint_at"),
  redeedPendingAt: __t.timestamp().name("redeed_pending_at"),
  placedAt: __t.timestamp().name("placed_at"),
});
